import { Outlet } from 'react-router-dom'

import AuthBrand from '@/components/auth/AuthBrand'

const AuthLayout = () => {
    return (
        <div className="flex min-h-screen items-center justify-center bg-white px-4 py-12">
            <div className="w-full max-w-md">
                <AuthBrand />
                <div className="mt-8">
                    <Outlet />
                </div>
                {/* <p className="mt-10 text-center text-xs text-[#7A8594]">
                    Mock login starts as{' '}
                    <span className="font-medium text-[#0C1324]">
                        admin@ogaboss.com
                    </span>{' '}
                    /{' '}
                    <span className="font-medium text-[#0C1324]">
                        Admin@123
                    </span>
                    . Update it anytime via Create password.
                </p> */}
            </div>
        </div>
    )
}

export default AuthLayout
